export default {
	"0775b92d58a5c7ab6552436c162ba136": "Product details page - Click for more coupons",
	"a5a1b35089fae034b3bdf78b9a303e00": "More coupons"
}
